export default __webpack_public_path__ + "static/media/Gloves of Haloga.6b5a5a8e.jpg";